module.exports = function getResource(label, vars = []) {
    let resources = {
        infoPublicProfile: 'Ces informations ne sont pas publiées sur votre profil public'
    };
    return resources[label];
};
